// recon-receivables-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'rcr.flag.old': 'Partida antigua de más de 90 días',
  'rcr.flag.overdue30': 'Vencida hace más de 30 días',
  'rcr.flag.negative': 'Saldo de cliente negativo',
  'rcr.flag.duplicate': 'Posible duplicado',
  'rcr.flag.partlyPaid': 'Pago parcial, aún abierta',
  'rcr.flag.creditNoteOpen': 'Nota de crédito sin compensar',
  'rcr.flag.collection': 'Aviso de recobro enviado',
  'rcr.flag.lossRisk': 'Riesgo de pérdida',
  'rcr.flag.missingDoc': 'Falta el documento de la factura',
  'rcr.flag.paidAfter': 'Cobrada después de la fecha del período',
  'rcr.flag.creditNoteAfter': 'Nota de crédito posterior a la fecha del período',
  'rcr.flag.disputed': 'Factura en disputa',
  'rcr.age.noDueDate': 'Sin fecha de vencimiento',
  'rcr.age.notDue': 'No vencida',
  'rcr.age.d1_30': '1–30 días de retraso',
  'rcr.age.d31_60': '31–60 días de retraso',
  'rcr.age.d61_90': '61–90 días de retraso',
  'rcr.age.over90': 'Más de 90 días de retraso',
  'rcr.collection.noticeOne': 'Aviso de recobro enviado',
  'rcr.collection.noticeMany': '{count} avisos de recobro enviados',
  'rcr.collection.reminderOne': 'Un recordatorio enviado',
  'rcr.collection.reminderMany': '{count} recordatorios enviados',
  'rcr.collection.invoiceSent': 'Factura enviada',
  'rcr.collection.notSent': 'No enviada',
  'rcr.collection.imported': 'Partida abierta importada',
  'rcr.type.creditNote': 'Nota de crédito',
  'rcr.type.invoice': 'Factura',
  'rcr.type.importedCredit': 'Crédito de cliente importado',
  'rcr.type.importedInvoice': 'Factura importada',
  'rcr.fallback.importedItem': 'Partida importada',
  'rcr.check.ledgerVsSubledger': 'Libro mayor frente al auxiliar de clientes',
  'rcr.check.old': 'Partidas antiguas de más de 90 días',
  'rcr.check.overdue30': 'Partidas vencidas hace más de 30 días',
  'rcr.check.negative': 'Saldos de cliente negativos',
  'rcr.check.partlyPaid': 'Pagada parcialmente pero aún abierta',
  'rcr.check.creditNoteOpen': 'Notas de crédito sin compensar',
  'rcr.check.duplicates': 'Posibles duplicados',
  'rcr.check.collection': 'Avisos de recobro enviados',
  'rcr.check.lossRisk': 'Partidas con riesgo de pérdida',
  'rcr.check.paidAfter': 'Cobro posterior',
  'rcr.check.creditNoteAfter': 'Nota de crédito posterior a la fecha del período',
  'rcr.check.direct': 'Asientos directos en la cuenta de control',
  'rcr.check.missingDoc': 'Falta el documento de la factura',
  'rcr.check.noSubledgerNote': 'Ninguna cuenta de control con auxiliar en el área',
});
